import React, { FC } from 'react';
import { Icon } from './Icon/icon.component';
import { ReactComponent as ChevronRight } from './assets/chevron-right.svg';

export const ChevronRightIcon: FC = () => (
  <Icon icon={ChevronRight} width={24} height={24} />
);
